import React from 'react';
import ReactDom from 'react-dom';
import { Router, Route, browserHistory } from 'react-router';
import UserList from './userlist';
import { AddUser, UpdateUser, UserStatisticsPage } from './manageuser';
import { ProfileEditor, UserStats } from './userinfo';
import { UserLogin } from './login';
import { ProfileOpLogsPage, UserOpLogsPage, OpLogsPage } from './oplogs';
import { UsersStatisticsPage } from './stats';
import { FeedbacksPage, UserFeedbacksPage } from './feedback';

ReactDom.render((
    <Router history={browserHistory}>
        <Route path='/users' component={UserList} />
        <Route path='/users/statistics' component={UsersStatisticsPage} />
        <Route path='/admin/adduser' component={AddUser} />
        <Route path='/user/:id/edit' component={UpdateUser} />
        <Route path='/user/:id/statistics' component={UserStatisticsPage} />
        <Route path='/user/:id/op_logs' component={UserOpLogsPage} />
        <Route path='/profile/edit' component={ProfileEditor} />
        <Route path='/profile/statistics' component={UserStats} />
        <Route path='/profile/op_logs' component={ProfileOpLogsPage} />
        <Route path='/profile/feedbacks' component={UserFeedbacksPage} />
        <Route path='/op_logs' component={OpLogsPage} />
        <Route path='/feedbacks' component={FeedbacksPage} />
        <Route path='/auth/login' component={UserLogin} />
    </Router>
), document.getElementById('main')
);



// WEBPACK FOOTER //
// ./js/user/entry.jsx